import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { switchMap } from 'rxjs/operators';
import { HtmlFormatterComponent } from 'src/app/components/data-table/html-formatter/html-formatter.component';
import {
  downloadEulaAttachment,
  hydrateEulaMedia,
  preserveEmptyBlockBreaks
} from 'src/app/pages/admin/eula/eula-content';
import { DocumentService } from 'src/app/services/document.service';
import { EulaService } from 'src/app/services/eula.service';
import { LoadingService } from 'src/app/services/loading.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-eula',
  imports: [HtmlFormatterComponent],
  templateUrl: './eula.component.html',
  styleUrls: ['./eula.component.scss']
})
export class EulaComponent implements OnInit, OnDestroy {
  objectUrls: string[] = [];
  content = '';

  constructor(
    private translate: TranslateService,
    private eulaService: EulaService,
    private documentService: DocumentService,
    private loadingService: LoadingService,
    private toastService: ToastService) { }

  ngOnInit() {
    this.getEula();
  }

  ngOnDestroy() {
    this.objectUrls.forEach((url) => URL.revokeObjectURL(url));
    this.objectUrls = [];
  }

  getEula() {
    this.loadingService.show();
    this.eulaService.getEula().pipe(
      switchMap((firstItem: any) => {
        if (!firstItem) {
          throw { status: 404 };
        }
        return hydrateEulaMedia(
          preserveEmptyBlockBreaks(firstItem.content || ''),
          (path) => this.documentService.getDocumentBlob(path)
        );
      })
    ).subscribe({
      next: ({ html, objectUrls }) => {
        this.loadingService.hide();
        this.objectUrls = objectUrls;
        this.content = html;
      },
      error: ({ status }) => {
        this.loadingService.hide();
        if (status === 404) {
          this.toastService.error(this.translate.instant('eula not found'));
        }
      }
    });
  }

  onContentClick(event: MouseEvent) {
    downloadEulaAttachment(event,
      (path) => this.documentService.getDocumentBlob(path),
      () => this.toastService.error(this.translate.instant('error'))
    );
  }
}
